import { usePaymentContext } from 'features/payment';

import Dialog from 'components/dialog';
import { useNavigation } from 'hooks/navigation/use-navigation';
import noop from 'utils/noop';

import { PaymentMethodSelectorHeader } from './payment-method-selector-header';
import { PaymentMethodSelectorOptions } from './payment-method-selector-options';
import { ContentWrapperDesktop, ScrollableView } from './styled';
import { IPaymentMethodSelectorProps } from './types';

export const PaymentMethodSelectorModal = ({
  isOpen,
  onClose,
  onConfirm,
  methods,
  selectedMethodId,
  isReloadDrawer,
  reloadSelectedMethodId = '',
  setIsGiftCardVisible = noop,
}: IPaymentMethodSelectorProps) => {
  const { goBack } = useNavigation();
  const { noPaymentMethodsAvailable } = usePaymentContext();

  return (
    isOpen && (
      <Dialog
        onDismiss={() => goBack()}
        modalAppearanceEventMessage={'Payment Methods'}
        showDialog={isOpen}
        contentWidth="auto"
        contentMaxWidth="560px"
        maxHeight="none"
        bodyComponent={
          <ContentWrapperDesktop>
            <PaymentMethodSelectorHeader
              isReloadDrawer={isReloadDrawer}
              noPaymentMethodsAvailable={noPaymentMethodsAvailable}
              onClose={onClose}
            />
            <ScrollableView>
              <PaymentMethodSelectorOptions
                {...{
                  onConfirm,
                  onClose,
                  methods,
                  selectedMethodId,
                  isReloadDrawer,
                  setIsGiftCardVisible,
                  reloadSelectedMethodId,
                }}
              />
            </ScrollableView>
          </ContentWrapperDesktop>
        }
      />
    )
  );
};
